import type { PurposePreselection } from "./types";
import { DEFAULT_CONSENT_API_BASE_URL } from "../constants";

export const ASSISTED_BASE_URL = DEFAULT_CONSENT_API_BASE_URL;

export const ASSISTED_CONFIG = {
  otpLength: 6,
  resendSeconds: 30,
  dialCode: "+91",
  channel: "sms",
  emailChannel: "email",
  otpPurpose: "login",
  mobileDigits: 10,
} as const;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DEFAULT_PURPOSE_PRESELECTION: PurposePreselection = "NONE";

export const ASSISTED_FALLBACK_MESSAGES = {
  notice: "Could not load the consent notice. Please try again.",
  createOtp: "Could not send the OTP. Please try again.",
  verifyOtp: "Could not verify the OTP. Please try again.",
  submit: "Could not submit your consent. Please try again.",
  audio: "Could not load audio narration. Please try again.",
} as const;

export const ASSISTED_HOST_ATTRIBUTE = "data-redacto-consent-assisted";

export const ASSISTED_IDS = {
  mobileInput: "redacto-assisted-mobile",
  emailInput: "redacto-assisted-email",
  otpInputPrefix: "redacto-assisted-otp-",
  verifyPanel: "redacto-assisted-verify",
  purposeContainerPrefix: "redacto-assisted-purpose-",
  resend: "redacto-assisted-resend",
  speakerSlot: "redacto-assisted-speaker",
} as const;

export const FOCUS_KEY_ATTRIBUTE = "data-focus-key";

export const FOCUS_KEYS = {
  language: "language",
  speaker: "speaker",
  acceptAll: "accept-all",
  primary: "primary",
  decline: "decline",
  editSelections: "edit-selections",
  switchMethod: "switch-method",
  changeContact: "change-contact",
  resend: "resend",
  close: "close",
  purpose: (purposeUuid: string) => `purpose:${purposeUuid}`,
  collapse: (purposeUuid: string) => `collapse:${purposeUuid}`,
  element: (purposeUuid: string, elementUuid: string) => `element:${purposeUuid}:${elementUuid}`,
} as const;

export const ASSISTED_DEFAULT_PRIMARY_COLOR = "#4f87ff";

export const ASSISTED_STYLE_ID = "redacto-assisted-styles";

export const MOBILE_QUERY = "(max-width: 768px)";
